import { T } from '../../../design/tokens';

/** Brandpar: Sage/Forrest og omvendt — fordelt stabilt pr. navn. */
const PAIRS = [
  { bg: T.accentLight, fg: T.accent },
  { bg: T.dark, fg: T.onDarkMuted },
];

function hash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export interface AvatarProps {
  name?: string;
  size?: number;
}

export function Avatar({ name = '?', size = 34 }: AvatarProps) {
  const initials = name.split(/\s+/).filter(Boolean).map((s) => s[0]).slice(0, 2).join('').toUpperCase();
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: size, height: size,
      borderRadius: 999, background: PAIRS[hash(name) % PAIRS.length].bg, color: PAIRS[hash(name) % PAIRS.length].fg, fontWeight: 700,
      fontSize: Math.round(size * 0.37), flexShrink: 0,
    }}>{initials}</span>
  );
}
